import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetApprovalStatusLabelComponent } from './asset-approval-status-label.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [AssetApprovalStatusLabelComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    AssetApprovalStatusLabelComponent
  ]
})
export class AssetApprovalStatusLabelModule { }
